// Query keys for the aws-account feature's server reads. Keyed by customer, so
// switching customers is a distinct cache entry rather than a stale render of
// the previous one's accounts.
export const awsAccountKeys = {
  accounts: (customerId: string) => ['aws-account', 'accounts', customerId] as const,
  baselineStatus: (customerId: string) => ['aws-account', 'baselineStatus', customerId] as const,
};
